<template>
<div class="chapter">
<div class="inner_page">
<p class="sp" id="ack"> </p>
<p class="bmh"><span class="epub-script">Acknowledgments</span></p>
<p class="tni">My friend Florence Olian for “How I’m Going to Make It to One Hundred.”</p>
<p class="stni">Virginia Kiser Hotchner for suggesting the title and much more.</p>
<p class="stni">Claire Panke and Anna Harding for their painstaking assistance.</p>
<p class="stni">Tracy and Holly Hotchner for bringing Ernie into my life.</p>
<p class="stni">Dr. Norman Kelman, in memorium.</p>
<p class="stni">Washington University Alumni Office</p>
<p class="stni">Andrew Padula, former V.P. for Production, Bigelow Tea Co., for his recollections.</p>
<p class="stni">Kathryn Huck for making the demands of editing this book a piece of St. Martin’s cake.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// acknowledgements.vue?4109e079